<p>
  Accept MyRobot.Cloud’s
  <a [href]="eulaUrl" target="_blank" style="text-decoration: underline"
    >EULA</a
  >
  (End User License Agreement) to continue.
</p>
